var map = {
	"./campana-alt.png": "d8a6",
	"./campana-login.png": "f96c",
	"./campana.png": "96e0",
	"./corporacionmedica-alt.png": "d2f2",
	"./corporacionmedica.png": "eca8",
	"./deragopyan-alt.png": "bfb8",
	"./deragopyan.png": "e842",
	"./vilella-alt.png": "9874",
	"./vilella.png": "7cb0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "69ae";